import {styled} from "@mui/system";
import {TimePicker} from "@mui/x-date-pickers";
import moment from "moment-timezone";
import {TextField} from "@mui/material";
import React from "react";

const onKeyDown = (event) => event.preventDefault();

const CompactTimePicker = styled(TimePicker)({
    '& input': {
        height: '0.625rem',
        width: '3.125rem'
    }
});

export default function CompactTimePickerComponent({label, value, roundingValue, onChange}) {
    return <CompactTimePicker
      ampm={false}
      label={label}
      value={moment(value)}
      onChange={onChange}
      minutesStep={roundingValue}
      renderInput={params => (
        <TextField
          {...params}
          size='small'
          error={false}
          onKeyDown={onKeyDown}/>)} sx={{margin: '0rem'}}/>
}